<template>
  <div>
    <v-container fill-height class="mt-md-5">
      <v-row>
        <v-col cols="12" md="6">
          <h1 class="mb-5">Status Pengajuan Surat</h1>
          <div class="subtitle-1">
            <p>Dengan layanan pemeriksaan status surat ini, mahasiswa dapat mengetahui status dari pengajuan suratnya kapan saja dan dimana saja. Jadi penduduk tidak perlu repot datang dan mengantri di kampus hanya untuk mengetahui status dari pengajuan suratnya.</p>
            <p>Cukup dengan memasukan <b>nomor referensi pengajuan</b> pada inputan di bawah, kemudian klik tombol <b>PERIKSA</b>.</p>
          </div>
          <v-form
            @submit.prevent="submitCheckSurat"
            ref="formcheck"
            v-model="formcheck.valid"
            lazy-validation>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="check.reference"
                  :rules="[rules.required]"
                  label="Nomor Referensi"
                  name="noref"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  v-if="!loading.check"
                  class="mt-1"
                  type="submit"
                  large
                  color="success"
                  :disabled="!formcheck.valid"
                  block>
                  <v-icon left>search</v-icon> Periksa
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col cols="12" md="6">
          <v-card
            :color="maincolor"
            dark
            raised>
            <v-card-title class="title py-3">Hasil Pemeriksaan</v-card-title>
            <v-card-text class="white text--primary py-3">
              <div class="text-center" v-if="loading.check">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <alertsp :alertdata="alertdata"></alertsp>
              <v-data-table
                class="table-nowrap"
                light
                :headers="hasil.headers"
                :items="hasil.data"
                hide-default-footer>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Check',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    panduan: null,
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Referensi', value: 'kd_skm' },
        { text: 'Surat', value: 'nama_js' },
        { text: 'Status', value: 'status_skm' },
      ],
      data: [],
    },
  }),
  mounted() {
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
      this.checkSuratByRef();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    checkSuratByRef() {
      this.alertdata.show = false;
      if (this.check.reference !== '') {
        this.hasil.data = [];
        this.loading.check = true;
        this.axios
          .post(
            this.api + '/public/checksurat',
            qs.stringify(
              this.check,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.hasil.data = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.check = false;
          });
      }
    },
    submitCheckSurat() {
      this.alertdata.show = false;
      if (this.$refs.formcheck.validate()) {
        this.checkSuratByRef();
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
